export { default } from 'Components/Stores/StoresMap/StoresMap'
